const SocialMediaIcons = () => {
return(
    <div
    className="flex justify-center md:justify-start my-10 gap-7"
    >
        {/* LinkedIn */}
        <a 
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkedin.com/in/sai-vikram-patnaik/"
        target="_blank"
        rel="noreferrer"
        
        >
            <img
            src="../assets/linkedin.png"
            alt="linkedin-link"
            />
        </a>
    
            {/* GitHub */}
        <a 
        className="hover:opacity-50 transition duration-500"
        href="https://github.com/Vikram126"
        target="_blank"
        rel="noreferrer"
        
        >
            <img
            src="../assets/github.png"
            alt="github-link"
            />
        </a>

        {/* Twitter */}
        <a 
        className="hover:opacity-50 transition duration-500"
        href="https://twitter.com/VikramUwU"
        target="_blank"
        rel="noreferrer"
        
        >
            <img
            src="../assets/X.png"
            alt="twitter-link"
            />
        </a>

        {/* Instagram */}
        <a 
        className="hover:opacity-50 transition duration-500"
        href="https://www.instagram.com/vickyonmeta"
        target="_blank"
        rel="noreferrer"
        
        >
            <img
            src="../assets/instagram.png"
            alt="instagram-link"
            />
        </a>

    </div>
);
};

export default SocialMediaIcons;